import axios from 'axios';
import { API_ROUTES } from '@/config/api-routes';
import { readPagedRows } from '@/shared/utils/spring-api';
const CATALOG_QUERY = 'page=0&size=1000&sort=id,asc';
/**
 * Minimal reference for Cases / Agent panel — issues + static enums only.
 * Provinces / districts / villages use {@link useCascadingLocationOptions};
 * branches, departments, and agents use {@link useEntityCatalog} on the panels that need them.
 */
export async function fetchCasePanelReference() {
    const issuesRes = await axios.get(`${API_ROUTES.issues}?${CATALOG_QUERY}`);
    const { rows: issueRows } = readPagedRows(issuesRes.data, issuesRes.headers);
    return {
        issues: issueRows.map((i) => ({ id: String(i.id ?? ''), name: i.name ?? '' })),
        provinces: [],
        districts: [],
        branches: [],
        departments: [],
        agents: [],
        callerTitles: [],
        socialMedias: [],
        priorities: [
            { label: 'HIGH', value: 'HIGH' },
            { label: 'MEDIUM', value: 'MEDIUM' },
            { label: 'LOW', value: 'LOW' },
        ],
    };
}
